const Footer = () => {
  return (
    <footer className="my-5">
      <div className="attribution">
        Challenge by
        <a
          href="https://www.frontendmentor.io?ref=challenge"
          target="_blank"
          rel="noreferrer"
        >
          Frontend Mentor
        </a>
        . Coded by <a href="https://github.com/Kingsleyaham">Aham Kingsley</a>.
      </div>

      <script src="./assets/js/main.js"></script>
    </footer>
  );
};

export default Footer;
